import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onVideoTimeUpdateBind  = this.onVideoTimeUpdate.bind(this)
        this.updateUIBind           = this.updateUI.bind(this)
        this.onVideoEndedBind       = this.onVideoEnded.bind(this)

        // UI
        this.$videoType     = this.el.dataset.videoType
        this.$progress      = this.$('progress')[0]
        this.$range         = this.$('range')[0]
        this.$video         = this.$('video')[0]
        this.$cta           = this.$('cta')[0]
        this.$currentTime   = this.$('currentTime')[0]

        // Events
        this.events = {
            click: {
                play: 'onPlayClick',
                video: 'onPlayClick',
            },
            input: {
                range: 'onRangeChange'
            }
        }

        this.currentTime = {
            oldMinutes: 0,
            oldSeconds: 0,
            minutes: 0,
            seconds: 0
        }

        this.eventsRequiringUIUpdate = 'play playing pause ended'.split(' ')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$video.addEventListener('timeupdate', this.onVideoTimeUpdateBind)
        this.$video.addEventListener('ended', this.onVideoEndedBind)

        for(let event of this.eventsRequiringUIUpdate) {
            this.$video.addEventListener(event, this.updateUIBind)
        }

        // Create custom event for other modules
        this.videoPlayerEnded = new CustomEvent('videoPlayerEnded', {
            detail: {
                el: this.el
            }
        })
    }

    unbindEvents() {
        this.$video.removeEventListener('timeupdate', this.onVideoTimeUpdateBind)
        this.$video.removeEventListener('ended', this.onVideoEndedBind)

        for(let event of this.eventsRequiringUIUpdate) {
            this.$video.removeEventListener(event, this.updateUIBind)
        }
    }

    ///////////////
    // Callbacks
    ///////////////
    onPlayClick() {
        this.$video.paused ? this.play() : this.pause()
    }

    onVideoTimeUpdate() {
        // Progress bar
        this.updateProgressBar()

        // Get current time
        this.currentTime.minutes = Math.round(this.$video.currentTime / 60)
        this.currentTime.seconds = Math.round(this.$video.currentTime % 60)

        if (this.currentTime.minutes != this.currentTime.oldMinutes || 
            this.currentTime.seconds != this.currentTime.oldSeconds) {
            this.updateCurrentTime(this.currentTime.minutes, this.currentTime.seconds)
        }
    }

    onVideoEnded() {
        // Dispatch custom event for other modules
        window.dispatchEvent(this.videoPlayerEnded)
    }

    onRangeChange() {
        this.$video.currentTime = this.$range.value * this.$video.duration
    }

    ///////////////
    // Methods
    ///////////////
    play(moduleID) {
        if(moduleID && moduleID != this.el.dataset.moduleVideoPlayer) return

        this.$video.play()
        this.updateUI()
    }

    pause(moduleID) {
        if(moduleID && moduleID != this.el.dataset.moduleVideoPlayer) return

        this.$video.pause()
        this.updateUI()
    }

    progressiveMute(moduleID) {
        if(moduleID && moduleID != this.el.dataset.moduleVideoPlayer) return

        let volume = 1
        const interval = setInterval(() => {
            if (volume > 0 ) {
                volume -= 0.05
                this.$video.volume = volume.toFixed(2)
            } else {
                clearInterval(interval)
                this.$video.muted = true
            }
        }, 20)
    }

    progressiveUnmute(moduleID) {
        if(moduleID && moduleID != this.el.dataset.moduleVideoPlayer) return

        let volume = 0
        this.$video.muted = false
        this.$video.volume = 0

        const interval = setInterval(() => {
            if (volume < 1 ) {
                volume += 0.05
                this.$video.volume = volume.toFixed(2)
            } else {
                clearInterval(interval)
            }
        }, 50)
    }

    updateProgressBar() {
        if (this.$video.duration) {
            this.$range.value = this.$video.currentTime / this.$video.duration
        } else {
            this.$range.value = 0
        }

        this.$progress.style.setProperty('--progress', this.$range.value)
    }

    updateCurrentTime(minutes, seconds) {
        const formattedTime = {
            minutes: this._pad(minutes, 2),
            seconds: this._pad(seconds, 2)
        }

        this.$currentTime.innerHTML = `${formattedTime.minutes}:${formattedTime.seconds}`
    }

    updateUI() {
        this.updateProgressBar()

        this.el.classList.toggle('is-playing', !this.$video.paused)
        this.el.classList.toggle('is-muted', this.$video.muted)
        this.el.classList.toggle('is-fullscreen', document.fullscreenElement == this.el)
    }

    reset(moduleID) {
        if(moduleID && moduleID != this.el.dataset.moduleVideoPlayer) return

        this.$video.currentTime = 0
    }

    _pad(x, width) {
        return String(x).padStart(width, '0')
    }
}
